import { marketingAgreementType, providerType } from '@repo/shared/types';
import type { MerchantResponse } from '@repo/api/endpoints/merchant';

import { P24MarketingAgreementsFormType } from './p24-marketing-agreements-form.schema';

const marketingCommonData = {
  // Hardcoded, marketing data are available only for P24
  provider: providerType.enum.przelewy24,
  timestamp: new Date().toISOString(),
} as const;

export const marketingAgreementsDataToSend = (
  data: P24MarketingAgreementsFormType,
  merchantResponseData: MerchantResponse,
) => [
  {
    ...marketingCommonData,
    accepted: Boolean(data.email),
    email: merchantResponseData.data.merchantData.email,
    type: marketingAgreementType.enum.email,
  },
  {
    ...marketingCommonData,
    accepted: Boolean(data.tel),
    phoneNumber: merchantResponseData.data.merchantData.phone,
    type: marketingAgreementType.enum.tel,
  },
  {
    ...marketingCommonData,
    accepted: Boolean(data.sms),
    phoneNumber: merchantResponseData.data.merchantData.phone,
    type: marketingAgreementType.enum.sms,
  },
];
